import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/feature/Reveal';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="Topics"
        title="按主题找瓜"
        description="不同圈子关注的点不太一样，先从你感兴趣的主题切进去。"
        align="center"
      />

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((category, index) => (
          <Reveal key={category.id} delay={index * 80} className={index === 0 ? 'sm:col-span-2 lg:col-span-1' : ''}>
            <Link
              to={`/frontline?category=${category.id}`}
              className="group flex flex-col h-full p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={category.icon}></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{category.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{category.description}</p>
              <span className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span>{category.count} 条记录</span>
                <span className="flex items-center gap-1 text-primary-700 font-medium">
                  去看看
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}